<!--<template>
  <div id="app1">
      <Carousel :slides="slides"></Carousel>
  </div>
</template>

<script>
import Carousel from './components/Carousel';

export default {
  name: 'AppS',
   data: () => ({
    slides: [
      "/wp-content/uploads/2024/01/hero.webp",
      "/wp-content/uploads/2024/01/hero-2.webp",
    ]
  }),
  components: {
    Carousel,
  }
}
</script>-->
<template>
  <div id="app1">
       <Slider></Slider>
  </div>
</template>

<script>
import Slider from './components/Slider';

export default {
  name: 'AppS',
  data: () => ({
    slides: [
      "",
      "",
      "",
      "",
    ]
  }),
  components: {
    Slider,
  }
}
</script>
